<template>
  <VanDialog
    :value="show"
    :show-confirm-button="false"
    :show-cancel-button="false"
    close-on-click-overlay
    class-name="cancel-limit-dialog"
    @click-overlay="onClose"
    @close="onClose"
  >
    <div class="cancel-limit">
      <img src="../../../assets/img-v2/ic_order_cancel_icon.png" class="icon" />
      <img src="../../../assets/img-v2/ic_order_cancel_bg.png" class="bg" />
      <div class="content">
        <div class="title">{{ title }}</div>
        <div v-html="desc" class="desc"></div>
        <div class="footer">
          <div class="btn confirm" @click="onConfirm">狠心取消</div>
          <div class="btn close" @click="onClose">再想想</div>
        </div>
      </div>
    </div>
  </VanDialog>
</template>

<script>

export default {
  components: {
  },
  model: {
    prop: "show",
    event: "update:show",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "提示",
    },
    maxCancelNum: {
      type: Number,
      default: 0,
    },
    cancelNum: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
    };
  },
  computed: {
    desc() {
      if (this.cancelNum <= 0) return ''
      const leftNum = this.maxCancelNum - this.cancelNum
      return leftNum <= 1 ? 
      `
        <div>您今日已取消${this.cancelNum}次订单</div>
        <div>如再次取消将无法再次下单</div>
      `
      : 
      `
        <div>您今日已取消${this.cancelNum}次订单</div>
        <div>取消订单次数超过${this.maxCancelNum}次将无法再次下单</div>
      `
    }
  },
  methods: {
    onConfirm() {
      this.$emit("confirm");
      this.$emit("update:show", false);
    },
    onClose() {
      this.$emit("close");
      this.$emit("update:show", false);
    }
  },
};
</script>

<style lang="scss" scoped>
.cancel-limit {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .icon {
    position: absolute;
    top: 0;
    transform: translateY(-50%);
    width: 109px;
    height: 88px;
    z-index: 1;
  }

  .bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 160px;
  }

  .content {
    position: relative;
    width: 100%;
  }

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #333333;
    line-height: 18px;
    text-align: center;
    padding-top: 72px;
  }
  
  .desc {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 15px;
    color: #666666;
    line-height: 25px;
    text-align: center;
    margin: 12px 0 16px 0;
  }
  
  .footer {
    display: flex;
    align-items: center;
    height: 80px;
    padding: 16px 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 16px;
  }
  .btn {
    flex: 1;
    height: 44px;
    border-radius: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .confirm {
    background: #F4F4F4;
    color: #999999;
  }
  .close {
    flex: 1;
    background: #006EFA;
    color: #FFFFFF;
    margin-left: 18px;
  }
}
.cancel-limit-dialog {
  overflow: unset;
}
</style>
